import { initFederation } from '@angular-architects/module-federation';
import { startupConfig } from './configuration-api-call';
import { fetchManifest, overrideRemote } from './custom-manifest-loader';

startupConfig().then((start) => {
    fetchManifest()
        .catch((err) => console.error(err))
        .then((config) => {
            if (config) {
                const override = overrideRemote(config);
                return initFederation(override, true);
            }
            return;
        })
        .catch((err) => console.error(err))
        .then(() => import('./bootstrap'))
        .catch((err) => console.error(err));
});
